import AboutUser from "@/api/AboutUser.js";
export const aboutUserModule = {
  namespaced: true,
  state: () => ({
    aboutUser: {},
  }),

  getters: {
    aboutUser: (state) => state.aboutUser,
  },

  mutations: {
    setUser(state, data) {
      state.aboutUser = data;
    },
  },

  actions: {
    getAboutUser({ commit }) {
      AboutUser.getAllAboutUser()
        .then((data) => {
          commit("setUser", data.data.data);
        })
        .then((err) => {});
    },
  },
};
